<template>
<div id="paymentScreen">
    <loader v-if="loading"/>
    <div v-show="!loading">
        <form @submit.prevent>
            <div id="paymentAlert" class="alert alert-warning" role="warning" style="margin-bottom: 20px;">
                <div style="margin-bottom: 10px; text-align: center;"><b>Wyoming State Historic Preservation Office</b></div>
                <div style="margin-bottom: 30px; text-align: center;"><b>WyoTrack File Search Refund Policy</b></div>
                <div style="margin-bottom: 10px;">All file search purchases ordered and paid for in the WyoTrack system are final. There will be no refunds issued for file searches purchased in WyoTrack.</div>
                <strong>Please Note:</strong> Once a file search has been submitted, payment is automatically created. <strong>The payment cannot be refunded.</strong> Please ensure you have the correct information before submitting.
            </div>
            <div class="form-group" v-bind:class="{ 'has-error': errors.has('') }">
                <label class="col-md-3 control-label">Number of Sections</label>
                <div class="col-md-8">
                        <span class="textValue">{{fileSearchCharge.sectionCount}}</span>
                </div>
            </div>
            <div class="form-group" v-bind:class="{ 'has-error': errors.has('') }">
                <label class="col-md-3 control-label">Charge per section</label>
                <div class="col-md-8">
                        <span class="textValue">${{fileSearchCharge.sectionCharge.toFixed(2)}}</span>
                </div>
            </div>
            <div class="form-group" v-bind:class="{ 'has-error': errors.has('') }">
                <label class="col-md-3 control-label">Subtotal</label>
                <div class="col-md-8">
                        <span class="textValue">${{subtotalCharge.toFixed(2)}}</span>
                </div>
            </div>
            <div class="form-group" v-bind:class="{ 'has-error': errors.has('') }">
                <label class="col-md-3 control-label">
                    Processing Fee ({{(paymentConfig.transactionFeeRate * 100.00).toFixed(2)}}% + ${{(paymentConfig.transactionFeeFlat || 0).toFixed(2)}})
                </label>
                <div class="col-md-8">
                        <span class="textValue">${{processingFee.toFixed(2)}}</span>
                </div>
            </div>
            <div class="form-group" v-bind:class="{ 'has-error': errors.has('') }">
                <label class="col-md-3 control-label">Total charge</label>
                <div class="col-md-8">
                    <span class="textValue"><strong>${{totalCharge.toFixed(2)}}</strong></span>
                </div>
            </div>
            <div v-if="!validationResult.isValid">
                <div class="col-md-12">
                    <validationResultDisplay :validationResult="validationResult" :header="''"></validationResultDisplay>
                </div>
                <div class="col-md-3">
                    <input class="btn btn-primary btn-block" v-on:click="cancel" value="Cancel">
                </div>
            </div>
            <div v-if="canSubmit">
                <div v-if="fileSearchCharge.sectionCharge === 0" class="col-md-2">
                    <input class="btn btn-primary btn-block" v-on:click="noCharge" value="Continue">
                </div>
                <div class="col-md-3" v-if="fileSearchCharge.sectionCharge != 0">
                    <input class="btn btn-primary btn-block" v-on:click="getSquareCheckout" value="Pay">
                </div>
                <div class="col-md-3" v-if="fileSearchCharge.sectionCharge != 0 && paymentConfig.enableMockSquareFlow">
                    <input class="btn btn-default btn-block" v-on:click="getMockSquareCheckout" value="Mock Pay">
                </div>
                <div class="col-md-3">
                    <input class="btn btn-primary btn-block" v-on:click="cancel" value="Cancel">
                </div>
                <div class="col-md-12" style="font-size: 13px;" v-if="fileSearchCharge.sectionCharge != 0">
                    *You will be re-directed to Square payment page once you clicked "Pay"
                </div>
            </div>

        </form>
    </div>
    </div>
</template>

<script>

import paymentService from '../services/paymentService'
import fileSearchService from '../services/fileSearchService'
import loggingService from '../services/util/loggingService'
import loader from '../components/Loader.vue'
import validationResultDisplay from '@/components/ValidationResultDisplay.vue'

export default {
    components: {
        loader,
        validationResultDisplay
    },
    mounted () {
        var container = this.$el.querySelector('#paymentAlert')
        container.scrollTop = 0
        loggingService.log(this.isDebug, 'FileSearchPayment', 'mounted for fileSearchId ' + this.fileSearchId)
        this.loadData()
    },
    data: function () {
        return {
            loading: true,
            isDebug: false,
            paymentConfig: {
            },
            fileSearchId: this.$route.params.fileSearchId,
            fileSearchCharge: {
                sectionCount: 0,
                sectionCharge: 60.00
            },
            validationResult: {
                isValid: false
            }
        }
    },
    computed: {
        subtotalCharge: function () {
            return this.fileSearchCharge.sectionCount * this.fileSearchCharge.sectionCharge
        },
        processingFee: function () {
            return (this.subtotalCharge * parseFloat(this.paymentConfig.transactionFeeRate)) +
            (this.fileSearchCharge.sectionCharge === 0 ? 0 : this.paymentConfig.transactionFeeFlat)
        },
        totalCharge: function () {
            return this.processingFee + this.subtotalCharge
            //return 10.10
        },
        canSubmit: function () {
            return this.validationResult.isValid
        }
    },
    watch: {
    },
    methods: {
        validatePaymentSubmit () {
            return fileSearchService.validatePaymentSubmit(this.$http, this.fileSearchId).then(response => {
                if (response.data) {
                    this.validationResult = response.data
                }
                return response
            })
        },
        loadPayment () {
            paymentService.getPaymentConfig(this.$http).then(response => {
                this.paymentConfig = response.data
                fileSearchService.plssLocationList(this.$http, this.fileSearchId).then(response2 => {
                    loggingService.log(this.isDebug, 'FileSearchPayment', 'got plss List: ' + response2.data.length)
                    this.fileSearchCharge.sectionCount = response2.data.length
                    paymentService.getBillingCodeByFileSearch(this.$http, this.fileSearchId).then(response3 => {
                        this.fileSearchCharge.sectionCharge = response3.data.amount
                        this.loading = false
                    })
                })
            })
        },
        loadData () {
            this.loading = true
            if (this.fileSearchId) {
                this.validatePaymentSubmit().then(result => {
                    if (this.validationResult.isValid) {
                        this.loadPayment()
                    } else {
                        this.loading = false
                    }
                })
            } else {
                this.$router.push('/')
            }
        },
        noCharge () {
            loggingService.log(this.isDebug, 'FileSearchPayment', 'mounted for fileSearchId ' + this.fileSearchId)
            fileSearchService.submitNoCharge(this.$http, this.fileSearchId).then(response => {
                this.$router.push('/FileSearch/' + this.fileSearchId)
            })
        },
        cancel () {
            this.$router.push('/FileSearch/' + this.fileSearchId)
        },
        getSquareCheckout () {
            this.loading = true
            paymentService.getSquareCheckout(this.$http, this.fileSearchId, paymentService.PaymentTypeEnum.FileSearch, `${window.location.protocol}//${window.location.host}`).then(response => {
                //console.log(response.data)
                if (response.data) {
                    window.location = response.data
                }
            })
        },
        getMockSquareCheckout () {
            this.loading = true
            paymentService.getMockSquareCheckout(this.$http, this.fileSearchId, paymentService.PaymentTypeEnum.FileSearch, `${window.location.protocol}//${window.location.host}`).then(response => {
                if (response.data && response.data.redirectUrl) {
                    window.location = response.data.redirectUrl
                } else {
                    this.loading = false
                }
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// FileSearchPayment.vue?089e0e2e